import { refreshToken, validateToken, isTokenExpired } from "./authService";

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  let accessToken = localStorage.getItem("access_token");
  const refreshTokenValue = localStorage.getItem("refresh_token");

  if (!accessToken) {
    console.error("No access token found. Redirecting to login.");
    localStorage.removeItem("refresh_token");
    window.location.href = "/home";
    throw new Error("No access token found");
  }

  if (isTokenExpired(accessToken)) {
    if (!refreshTokenValue) {
      console.error("No refresh token found. Redirecting to login.");
      localStorage.removeItem("access_token");
      window.location.href = "/home";
      throw new Error("No refresh token found");
    }
    try {
      // If the access token is expired, attempt to refresh it using the refresh token
      accessToken = await refreshToken(refreshTokenValue);
      localStorage.setItem("access_token", accessToken);
    } catch (error) {
      console.error("Failed to refresh token:", error);
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      window.location.href = "/home";
      throw error;
    }
  }

  // Optionally validate the token with the backend
  const isValid = await validateToken();
  if (!isValid) {
    console.error("Token is invalid or revoked. Redirecting to login.");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.href = "/home";
    throw new Error("Token is invalid or revoked");
  }

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export async function postWithUsername(url: string, username: string): Promise<Response> {
  if (!username) {
    throw new Error("Username is required");
  }

  try {
    const response = await fetchWithAuth(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userName: username }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("Error in postWithUsername:", error);
    throw error;
  }
}

export async function postWithMaterialParams(url: string, params: { job_id: string, client_id: string, main_table_name: string, layer_name: string, base_dataset: boolean}) {
  const response = await fetchWithAuth(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });
  return response;
}

export async function postWithUserTableParams(url: string, params: { job_id: string; client_id: string; username: string }) {
    return fetchWithAuth(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
    });
}

export async function postWithUserFlowParams(url: string, params: { job_id: string; client_id: string; username: string; flow_name: string }) {
    return fetchWithAuth(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(params),
    });
}